module.exports = __webpack_public_path__ + "static/media/duetigli-trebbiano.5e1d9e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/duetigli-trebbiano.png
// module id = 796
// module chunks = 0